import { type FunctionalComponent, h } from '@stencil/core';

import { DashboardProductsList } from './dashboard-products-list/dashboard-products-list';
import type {IDashboardDesktopView} from '../dashboard-views/dashboard-desktop-view';
import type {SearchProduct} from '../../../../../../api/model/response/documents/public/Product';
import {DashboardProductsSkeleton} from './dashboard-products-skeleton';
import type {WCEventData} from '../../../../../../api/model/response/documents/SearchResult';


interface IProducts extends Pick<IDashboardDesktopView, 'eolDiscontinuedResults' | 'query' | 'labelProvider' | 'isAdditionalConditionsWidgetActive' | 'isMiaPromotionWidget' | 'miaData' | 'strategies' | 'resultClickAnalytics' | 'country'| 'language' | 'isEcommerceMode' | 'eShop' | 'rtl' | 'brand' | 'lazyLoadImages' | 'isSubstitutionTool' | 'resultRenderer'> {
  products: SearchProduct[];
  tabName: string;
  tabCount: number;
  targetTab: string;
  subTitle: boolean;
  isProductData: boolean;
  isMySeVersion?: boolean
  useSkeleton?: boolean;
  sectionIsLoading?: boolean;
  wcEventData?: WCEventData;
  isUnifiedCheckout?: boolean;
  priceBannerComponent?: boolean;
}

export const DashboardProducts: FunctionalComponent<IProducts> = ({
  ...props
}) => {

    if (props.sectionIsLoading && props.useSkeleton) {
      return <DashboardProductsSkeleton picturePlaceholder={true} blocks={5} />;
    }

    return (
      props.isProductData && (
        <section
          class={{
            'dashboard__products--carousel-myse': (props.eolDiscontinuedResults?.documents?.length || 0) + (props.products.length || 0) > 4 && (props.isMySeVersion),
            'dashboard__products': (props.eolDiscontinuedResults?.documents?.length || 0) + (props.products.length || 0) > 1 && ((props.products.length || 0) <= 4 || !props.isMySeVersion),
            'dashboard__products--single': (props.eolDiscontinuedResults?.documents?.length || 0) + (props.products.length || 0) === 1
          }}
        >

          {props.products.length > 4 ? (
            <uiaas-search-dashboard-carousel
              tabName={props.tabName}
              strategies={props.strategies}
              resultRenderer={props.resultRenderer}
              resultClickAnalytics={props.resultClickAnalytics}
              products={props.products}
              tabCount={props.tabCount}
              labelProvider={(e, f) => props.labelProvider(e, f)}
              country={props.country}
              language={props.language}
              isEcommerceMode={props.isEcommerceMode}
              eShop={props.eShop}
              rtl={props.rtl}
              targetTab={props.targetTab}
              subTitle={props.subTitle}
              brand={props.brand}
              lazyLoadImages={props.lazyLoadImages}
              term={props.query}
              isSubstitutionTool={props.isSubstitutionTool}
              eolDiscontinuedResults={props.eolDiscontinuedResults}
              isAdditionalConditionsWidgetActive={props.isAdditionalConditionsWidgetActive}
              isMiaPromotionWidget={props.isMiaPromotionWidget}
              miaData={props.miaData}
              wcEventData={props.wcEventData}
              isUnifiedCheckout={props.isUnifiedCheckout}
              isMySeVersion = {props.isMySeVersion}
              priceBanner={props.priceBannerComponent}
            />
          ) : (
            <DashboardProductsList
              tabName={props.tabName}
              strategies={props.strategies}
              resultRenderer={props.resultRenderer}
              resultClickAnalytics={props.resultClickAnalytics}
              products={props.products}
              labelProvider={(e, f) => props.labelProvider(e, f)}
              country={props.country}
              language={props.language}
              isEcommerceMode={props.isEcommerceMode}
              eShop={props.eShop}
              rtl={props.rtl}
              subTitle={props.subTitle}
              lazyLoadImages={props.lazyLoadImages}
              isDashboardListVariant={true}
              isSubstitutionTool={props.isSubstitutionTool}
              eolDiscontinuedResults={props.eolDiscontinuedResults}
              isAdditionalConditionsWidgetActive={props.isAdditionalConditionsWidgetActive}
              isMiaPromotionWidget={props.isMiaPromotionWidget}
              miaData={props.miaData}
              wcEventData={props.wcEventData}
              isUnifiedCheckout={props.isUnifiedCheckout}
              term={props.query}
              isMySeVersion = {props.isMySeVersion}
              priceBanner={props.priceBannerComponent}
            />
          )}
        </section>)
    );
};
